@if (error$ | async; as generalError) {
<ish-server-error [error]="generalError" [type]="type$ | async" />
} @else {
<ish-error />
}
